export default function emailRestrictionSuccessMsgTemplate(successText) {
  return $(`
    <div class="email-restriction__success-msg">
      <svg
        class="email-restriction__success-msg-icon"
        aria-hidden="true"
        focusable="false"
      >
        <use xlink:href="#email-restriction-success-msg-icon"></use>
      </svg>
      <span class="email-restriction__success-msg-text">
        ${successText}
      </span>
    </div>
  `);
}